import { useState } from "react";
import { toast } from "sonner";
import { capi, formatApiError, setCustomerSession } from "@/lib/api";

export const CustomerGate = ({ onAuthed, heading = "Your account", note = "Create a quick account (or log in) so we can reply to you right here — pricing, links, invoices and bookings all land in your private conversation." }) => {
  const [mode, setMode] = useState("register");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = mode === "register"
        ? await capi.post("/auth/customer/register", form)
        : await capi.post("/auth/customer/login", { email: form.email, password: form.password });
      setCustomerSession(data.token, data.customer);
      toast.success(mode === "register" ? "Account created — welcome" : "Welcome back");
      onAuthed(data.customer);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full bg-transparent border-b border-[#C5A059] pb-3 text-base placeholder:text-[#1A1A1A]/35 focus:outline-none focus:border-[#9E7B3A] transition-colors duration-300";

  return (
    <div data-testid="customer-gate">
      <p className="text-[10px] tracking-[0.35em] uppercase text-[#9E7B3A] mb-2">{heading}</p>
      <p className="text-sm font-light text-[#4A4A4A] mb-6">{note}</p>
      <form onSubmit={submit} className="space-y-5" data-testid="customer-gate-form">
        {mode === "register" && (
          <input required value={form.name} onChange={(e) => set("name", e.target.value)}
            placeholder="Your name" aria-label="Name" data-testid="gate-name" className={inputCls} />
        )}
        <input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)}
          placeholder="Your email" aria-label="Email" data-testid="gate-email" className={inputCls} />
        <input required type="password" minLength={6} value={form.password} onChange={(e) => set("password", e.target.value)}
          placeholder={mode === "register" ? "Choose a password (6+ characters)" : "Your password"} aria-label="Password"
          data-testid="gate-password" className={inputCls} />
        <button type="submit" disabled={busy} data-testid="gate-submit"
          className="w-full bg-[#1A1A1A] text-white text-xs tracking-[0.3em] uppercase py-4 hover:bg-[#9E7B3A] disabled:opacity-50 transition-colors duration-300">
          {busy ? "One moment…" : mode === "register" ? "Create Account" : "Log In"}
        </button>
      </form>
      <button type="button" onClick={() => setMode(mode === "register" ? "login" : "register")} data-testid="gate-toggle"
        className="mt-5 text-xs tracking-[0.2em] uppercase text-[#9E7B3A] hover:text-[#1A1A1A] transition-colors duration-300">
        {mode === "register" ? "Already have an account? Log in" : "New here? Create an account"}
      </button>
    </div>
  );
};
